module.exports = __webpack_public_path__ + "static/media/zola-theme-icons.53fe11b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/zola-theme-icons.svg?24613844
// module id = 2399
// module chunks = 50